import { render } from "./create_portal.html?vue&type=template&id=3b29383b&external"
import script from "./create_portal.js?vue&type=script&lang=js&external"
export * from "./create_portal.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__